import React from 'react';
import IconInvoker from '../Icons/IconInvoker';
import './ButtonInput.scss';

const ButtonInput = ({id, className, disabled, title, handleClick, isLoading = false, size = null, icon = null, width = null}) => (
    <button
        className={`${className} ${disabled && ' disabled'} ${size !== null && size}`}
        disabled={disabled}
        onClick={handleClick}
        id={`${id}`}
        style={{minWidth: width ? width +'px' : 'initial', maxWidth:  width ? width +'px' : 'initial'}}
    >{isLoading && <i className="fa fa-spinner fa-spin"/>}
        <div className="btn-body">
            {icon && new IconInvoker(icon, 'm-r-15')}
            <span className="btn-title">{!isLoading && title}</span>
        </div>
    </button>
);

export default ButtonInput;


// WEBPACK FOOTER //
// ./src/components/Common/ButtonInput/ButtonInput.js